import React from "react";
import Background from "../../assets/icons/Rectangle 496.svg";
import Macbook from "../../assets/icons/Frame 1 (1).svg";

const HeroImage = ({ signup }) => {
  return (
    <>
      <div className="relative">
        <div className="object-cover">
          <img className="h-screen" src={Background} alt="Background" />
        </div>
        {signup ? (
          ""
        ) : (
          <>
            <div className="object-cover">
              <img
                src={Macbook}
                alt="macbook"
                className="h-70% absolute top-1.5 -left-31 2xl:h-70%"
              />
            </div>
            <div className="text-center space-y-2 absolute lg:px-7 lg:!bottom-15vh">
              <p className="text-5xl font-thin text-white font-custom lg:text-40 2xl:text-5xl">
                #1 App For Daily Auto Care Deals
              </p>
              <p className="text-lg text-white font-thin lg:text-base 2xl:text-lg">
                Gain Access To Local Automotive Businesses with Deals on
                Everyday Services for Your Car
              </p>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HeroImage;
